<template><div><div>
    <svg data-v-3cdef250="" version="1.1" id="图层_1" width="383" height="40" xml:space="preserve">
        <rect data-v-3cdef250="" x="66.5" y="0" width="250" height="40" style="fill: none; stroke: rgb(8, 173, 247); stroke-miterlimit: 10;"></rect>
        <rect data-v-3cdef250="" x="71.5" y="5" width="240" height="30" style="fill: rgba(0, 188, 209, 0.5); opacity: 0.5;"></rect>
        <g data-v-3cdef250="">
            <line data-v-3cdef250="" x1="0" y1="20" x2="96.5" y2="20" style="fill: none; stroke: rgba(0, 188, 209, 0.5); stroke-width: 2; stroke-miterlimit: 10;"></line>
            <line data-v-3cdef250="" x1="36.5" y1="20" x2="96.5" y2="20" style="fill: none; stroke: rgb(8, 173, 247); stroke-width: 4; stroke-miterlimit: 10;"></line>
        </g>
        <g data-v-3cdef250="">
            <line data-v-3cdef250="" x1="316.5" y1="20" x2="383" y2="20" style="fill: none; stroke: rgba(0, 188, 209, 0.5); stroke-width: 2; stroke-miterlimit: 10;"></line>
            <line data-v-3cdef250="" x1="286.5" y1="20" x2="346.5" y2="20" style="fill: none; stroke: rgb(8, 173, 247); stroke-width: 4; stroke-miterlimit: 10;"></line>
        </g><text data-v-3cdef250="" text-anchor="middle" font-family="AlimamaAgileVF-Thin" x="50%" y="63%" font-size="18px" font-weight="700" style="fill: rgb(255, 255, 255);"> {{title}}</text>
    </svg></div></div></template><script> export default {
    props: ["title"],
    data() {
        return {}
    },
    created() {},
    methods: {}
}</script><style scoped></style>